import React, { useContext, useEffect, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import { BackgroundContext } from '../../libs/BackgroundProvider';
import { useGameContext } from "../../libs/GameProvider";
import CountDown from '../game-common/CountDown';
import GamePrintingControl from './GamePrintingControl';
import GamePrintingHintsAndDescriptionModal from './GamePrintingHintsAndDescriptionModal';
import GamePrintingPreGame from './GamePrintingPreGame';

interface GamePrintingGameProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish?: () => void;
}

function GamePrintingGame(props: GamePrintingGameProps) {
  const { playClick } = useContext(AudioContext);
  const { setBg } = useContext(BackgroundContext);
  const { game, dispatch } = useGameContext();
  const [started, setStarted] = useState(false);
  const [stopped, setStopped] = useState(false);
  // const [lives, setLives] = useState(3);

  useEffect(() => {
    console.log(game);
    if ('game-printing' === game.status) {
      setBg(null);
    }
  }, [game, setBg]);

  const timesout = () => {
    // dispatch({ type: 'game-printing', state: 'fail' })
  }

  const onConfirm = (correct: boolean) => {
    // playClick();
    setStopped(true);
    setTimeout(() => {
      if (correct) {
        dispatch({ type: 'game-printing', state: 'success' });
      } else {
        dispatch({ type: 'game-printing', state: 'fail' });
      }
    }, 3000);
  }

  const onIntroFinish = () => {
    setStarted(true);
  }

  return (
    <div className="fullscreen game-printing">
      <div className="">
        <CountDown started={started} stopped={stopped} timesout={timesout}></CountDown>

        <GamePrintingControl onConfirm={onConfirm} started={started} />

        <GamePrintingHintsAndDescriptionModal />

        <GamePrintingPreGame onFinish={onIntroFinish} />
      </div>
    </div>
  )
}

export default GamePrintingGame;
